module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@2x-e8170a6977d88a8a68ec11e629ebd7ac.png";